import { render, staticRenderFns } from "./iku_daerah.vue?vue&type=template&id=f6296b7e&"
import script from "./iku_daerah.vue?vue&type=script&lang=js&"
export * from "./iku_daerah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports